export const DEFAULT_SITE_TITLE = 'AfricaData — Plateforme de collecte et publication scientifique';
export const DEFAULT_SITE_DESCRIPTION =
  'AfricaData : plateforme de collecte, validation et diffusion de la recherche scientifique africaine.';
